import React from 'react';
import { SelectionsProvider } from './context/SelectionsContext';
import { EliteSelectionsWidget } from './components/EliteSelectionsWidget';

function App() {
  return (
      <SelectionsProvider>
        <EliteSelectionsWidget />
      </SelectionsProvider>
  );
}

export default App;
